import React from 'react';

interface FeatureItemProps {
  icon: string;
  title?: string;
  subtitle?: string;
  description?: string;
  value?: string;
  variant?: 'icon-top' | 'icon-row';
}

export default function FeatureItem({
  icon,
  title,
  subtitle,
  description,
  value,
  variant = 'icon-row',
}: FeatureItemProps) {
  if (variant === 'icon-top') {
    return (
      <div className="col border-end border-light-subtle">
        <i className={`${icon} text-muted fs-4 mb-2`}></i>
        {subtitle && (
          <small className="d-block text-muted text-uppercase fw-semibold mb-1" style={{ fontSize: '0.65rem' }}>
            {subtitle}
          </small>
        )}
        {value && <strong className="fs-5 text-dark">{value}</strong>}
      </div>
    );
  }

  return (
    <div className="d-flex align-items-start gap-3">
      <div
        className="rounded-3 p-3 d-flex align-items-center justify-content-center"
        style={{ backgroundColor: '#EEF4F8', color: '#13315C', width: '50px', height: '50px' }}
      >
        <i className={icon}></i>
      </div>
      <div>
        {title && <h6 className="fw-bold mb-1">{title}</h6>}
        {description && <span className="text-muted small">{description}</span>}
      </div>
    </div>
  );
}
